export const GENERIC_CODE_TEMPLATE = `module.exports = function(prevStep, allSteps, trigger) {
    /*

    * prevStep: Contains previous step data
    interface prevStep {
        header: Record<string, any>; // header from trigger
        body: any; // data from previous step
    }

    * allSteps: Contains data from all previous steps
    type allStepsType = any[]; // all data from previous steps, index 0 is first step in workflow

    * trigger: Contains workflow trigger data
    interface triggerInterface {
        header: Record<string, any>; // header from trigger
        body: any; // data from trigger
    }

    */

    // Code goes here


    // You must return something from this step. Pass through the previous step's body as default.
    return prevStep.body;
}
`;
